module.exports = __webpack_public_path__ + "static/media/delete_account_logout.9ad41180.jpg";